import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icons from '../icons';
import '../../styles/index.css';

export default function RefundPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ backgroundColor: '#FFFFFF', minHeight: '100vh' }}>
            {/* Header */}
            <div style={{
                height: '50px', position: 'sticky', top: 0, left: '0px', right: '0px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
                alignItems: 'center', zIndex: 1000, backgroundColor: '#FFFFFF', borderBottom: '1px solid #E0E0E0'
            }}>
                <Link to="/" style={{ paddingLeft: '15px', color: 'green', textDecoration: 'none' }}>
                    <Icons icon="logo" size="160" color="#429a37" />
                </Link>
                <Link to="/" style={{ paddingRight: '20px', textDecoration: 'none', color: '#429a37', fontSize: '14px', fontFamily: "'Roboto', sans-serif", fontWeight: 500 }}>
                    ← Back to Home
                </Link>
            </div>

            {/* Content */}
            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
                <h1 style={{ fontSize: '36px', fontFamily: "'Roboto', sans-serif", fontWeight: 600, marginBottom: '10px', color: '#000000' }}>
                    Refund Policy
                </h1>
                <p style={{ fontSize: '14px', fontFamily: "'Roboto', sans-serif", color: '#666666', marginBottom: '40px' }}>
                    Last Updated: December 31, 2024
                </p>

                <div style={{ fontFamily: "'Roboto', sans-serif", lineHeight: '1.8', color: '#333333' }}>
                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>1. Return Period</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            At Powerbox Energy Systems LLC, we want you to be completely satisfied with your purchase. If you are not satisfied with your Powerbox product, 
                            you may return it within 14 days of delivery for a full refund, subject to the conditions outlined in this policy.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>2. Eligibility for Refund</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            To be eligible for a refund, the following conditions must be met:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li>The product must be returned within 14 days of delivery</li>
                            <li>The product must be in its original condition and packaging</li>
                            <li>All accessories, manuals, and components must be included</li>
                            <li>The product must not show signs of use, damage, or modification</li>
                            <li>Proof of purchase (receipt or order confirmation) must be provided</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>3. Non-Refundable Items</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            The following items are not eligible for refund:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li>Products that have been installed or used</li>
                            <li>Products returned after the 14-day return period</li>
                            <li>Products damaged due to misuse, negligence, or improper handling</li>
                            <li>Custom or specially ordered products</li>
                            <li>Products without original packaging or missing components</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>4. How to Request a Refund</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            To request a refund, please follow these steps:
                        </p>
                        <ol style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li style={{ marginBottom: '10px' }}>Contact our customer support team at Support@powerbox.com.ng or call 09070811425</li>
                            <li style={{ marginBottom: '10px' }}>Provide your order number and reason for return</li>
                            <li style={{ marginBottom: '10px' }}>Wait for confirmation and return authorization from our team</li>
                            <li style={{ marginBottom: '10px' }}>Carefully package the product in its original packaging</li>
                            <li style={{ marginBottom: '10px' }}>Ship the product to the address provided by our team</li>
                        </ol>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            <strong>Note:</strong> Do not ship products back without prior authorization. Unauthorized returns will not be accepted.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>5. Return Shipping Costs</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Return shipping costs are the responsibility of the customer, except in cases where:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li>The product was defective or damaged upon arrival</li>
                            <li>We shipped the wrong product</li>
                            <li>The product does not match its description</li>
                        </ul>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            In these cases, we will provide a prepaid return shipping label or reimburse reasonable shipping costs.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>6. Refund Processing</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Once we receive and inspect your returned product, we will notify you of the approval or rejection of your refund.
                        </p>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            If approved, your refund will be processed within 5-10 business days to your original payment method. Please note that depending on your 
                            payment provider, it may take additional time for the refund to appear in your account.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>7. Exchanges</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We do not offer direct exchanges. If you need a different product, please return the original item for a refund and place a new order.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>8. Damaged or Defective Products</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            If you receive a damaged or defective product, please contact us immediately at Support@powerbox.com.ng with:
                        </p>
                        <ul style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <li>Photos or videos of the damage or defect</li>
                            <li>Your order number</li>
                            <li>A detailed description of the issue</li>
                        </ul>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            We will arrange for a replacement or full refund, including return shipping costs.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>9. Warranty vs. Refund</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            Please note that our refund policy is separate from our warranty. Products that develop issues after the 14-day return period may be covered 
                            under our 1-year warranty and 10-year guarantee. Please refer to our Terms and Conditions for warranty information.
                        </p>
                    </section>

                    <section style={{ marginBottom: '30px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px', color: '#000000' }}>10. Contact Us</h2>
                        <p style={{ fontSize: '16px', marginBottom: '15px' }}>
                            If you have any questions about our Refund Policy, please contact us:
                        </p>
                        <div style={{ fontSize: '16px', marginLeft: '20px', marginBottom: '15px' }}>
                            <p><strong>Powerbox Energy Systems LLC</strong></p>
                            <p>Ad1, Makarfi Street</p>
                            <p>Constitution, Kaduna</p>
                            <p>Nigeria</p>
                            <p>Email: Support@powerbox.com.ng</p>
                            <p>Phone: 09070811425</p>
                        </div>
                    </section>
                </div>
            </div>

            {/* Footer */}
            <div style={{ backgroundColor: '#F5F5F5', padding: '20px', textAlign: 'center', marginTop: '40px', borderTop: '1px solid #E0E0E0' }}>
                <p style={{ fontSize: '14px', fontFamily: "'Roboto', sans-serif", color: '#666666' }}>
                    © 2024 Powerbox Energy Systems LLC. All Rights Reserved.
                </p>
            </div>
        </div>
    );
}
